module.exports = __webpack_public_path__ + "img/gg-2.0b5a485a.svg";